class UserDeclined extends Error {}

export const askConfirmation = (message, content = "", { icon = "warning" }) => {
  const done = new Promise((resolve) =>
    $("#modalConfirm").on("hidden.bs.modal", resolve)
  );
  return new Promise((resolve, reject) =>
    window.showModalConfirm(
      message,
      content,
      icon,
      () => done.then(() => resolve(true)),
      () => done.then(() => reject(new UserDeclined(content))),
      "OK",
      "CANCEL"
    )
  );
};

export const mayDecline = (error) => {
  if (error instanceof UserDeclined) return error /*its ok*/;
  throw error;
};
